export default {
  title: 'Restablecer contraseña',
  description: 'Te enviaremos un enlace para restablecer tu contraseña.',
  sent: 'Correo enviado.',

  form: {
    email: {
      title: 'Correo electrónico',
      placeholder: 'Introduce el correo',
    },
    button: {
      title: 'Restablecer contraseña',
    },
    error_messages: {
      error1: 'Información faltante',
    },
  },
};
